import { Alert, Button } from '@mui/material'
import React from 'react'

import useAuth from 'hooks/use-auth'
import { trans, TranslationLanguage } from 'i18n/translate'
import { pluralize } from 'utils/strings'

interface AlertDetails {
  action: string
  actionUrl: string
  message: string
  shouldDisplay: boolean
}

// todo: EN-6051 save for potential use later?

// interface HideAlertStore {
//   hidden: boolean
//   date: string
// }
// type AlertPreference = Record<string, HideAlertStore>
// type TeamAlertPreferencesStore = Record<string, AlertPreference>

//   /**
//    * If the user has hidden the banner within the same day, it will always suppress the Alert from
//    * showing. On the next day, if the banner was hidden, it will make it visible again by deleting the
//    * localStore value for this banner on this teamId.
//    * The persistence is based on a combination of the teamId and paywallKey
//    */
// const userHasHiddenBanner = useCallback(
//     (paywallKey: string) => {
//       const storedHiddenState: TeamAlertPreferencesStore =
//         store.get('alertPreferences')
//       const teamSpecificState: AlertPreference = storedHiddenState
//         ? storedHiddenState[currentTeamId]
//         : null
//       const alertHiddenState: HideAlertStore = teamSpecificState
//         ? teamSpecificState[paywallKey]
//         : null
//       if (alertHiddenState) {
//         // we only hide the banner for one day, if that is exceeded, then we destory the preference, and
//         // re-present the banner.
//         if (moment().diff(moment(alertHiddenState.date), 'days') > 0) {
//           const updatedKeyItem = { ...storedHiddenState }
//           delete updatedKeyItem[currentTeamId][paywallKey]
//           store.set('alertPreferences', updatedKeyItem)
//         }
//         // else listen to the preference stored in localStorage
//         return (
//           moment().diff(moment(alertHiddenState.date), 'days') === 0 &&
//           alertHiddenState?.hidden
//         )
//       } else {
//         return false
//       }
//     },
//     [currentTeamId]
//   )

function getAlertDetails({
  contractExpirationImminent,
  daysUntilContractExpiration,
  isTrial,
  language = 'en'
}: {
  contractExpirationImminent: boolean
  daysUntilContractExpiration: number
  isTrial: boolean
  language?: TranslationLanguage
}): AlertDetails {
  const dayString = `${daysUntilContractExpiration} ${pluralize(
    'day',
    daysUntilContractExpiration
  )}`

  return {
    action: trans('navigation.header_alert.action'),
    actionUrl: 'https://www.gremlin.com/contact/',
    message: isTrial
      ? trans(
          'navigation.header_alert.message_trial',
          {
            dayString
          },
          language
        )
      : trans(
          'navigation.header_alert.message_entitlements',
          {
            dayString
          },
          language
        ),
    shouldDisplay: Boolean(contractExpirationImminent)
  }
}

export const HeaderAlert: React.FC = () => {
  const { contractExpirationImminent, daysUntilContractExpiration, isTrial } =
    useAuth()

  const alertDetails = getAlertDetails({
    contractExpirationImminent,
    daysUntilContractExpiration,
    isTrial
  })

  return (
    <div
      css={{
        display: 'flex',
        alignItems: 'center',
        marginLeft: 'auto'
      }}
    >
      {alertDetails.shouldDisplay && (
        <Alert
          data-test-header-alert
          action={
            <Button
              data-test-alert-action-button
              css={{
                marginRight: 4,
                marginTop: -1
              }}
              href={alertDetails.actionUrl}
              size="small"
            >
              {alertDetails.action}
            </Button>
          }
          severity="info"
          sx={{ marginTop: 1, marginBottom: 1 }}
        >
          {alertDetails.message}
        </Alert>
      )}
    </div>
  )
}
